import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { type Middleware, type PayloadAction } from '@reduxjs/toolkit';

/**
 * Creates a redux logger middleware.
 *
 * @param {boolean} [enable] whether logger is enabled
 *
 * @returns {Middleware} redux logger middleware
 */
export function configureLogger(): Middleware {
	return createLogger({
		duration: true,
		timestamp: true,
		diff: true,
		collapsed: (
			_getState: any,
			_action: PayloadAction<any>,
			logEntry: any,
		) => !logEntry.error,
	});
}

/**
 * Creates the middleware array.
 *
 * @param {boolean} debug whether app is in debug mode
 *
 * @returns {MiddlewareArray<Middleware>} middleware array
 */
export function configureMiddleware(debug = false): Middleware[] {
	const middleware: Middleware[] = [thunk];

	if (debug) middleware.push(configureLogger());

	return middleware;
}
